import { MinusSquareIcon, PlusSquareIcon } from "lucide-react";
import React, { useState } from "react";
import { FaLinkedinIn } from "react-icons/fa";
import HeroSection from "../components/common/HeroSection";

const teamSections = [
  {
    title: "Leadership Team",
    members: [
      {
        name: "ABC",
        role: "President",
        image: "/assets/images/team/p1.jpeg",
        bio:
          "I enjoy being a concierge to my friends. My greatest professional and personal enjoyment comes from serving others.",
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
      {
        name: "DEF",
        role: "CEO",
        image: "/assets/images/team/p2.jpg",
        bio:
          "I enjoy being a concierge to my friends. My greatest professional and personal enjoyment comes from serving others.",
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
    ],
  },
  {
    title: "Sales Team",
    members: [
      {
        name: "ABC",
        role: "EVP, Sales Operations",
        image: "/assets/images/team/p1.jpeg",
        bio:
          "I enjoy being a concierge to my friends. My greatest professional and personal enjoyment comes from serving others.",
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
      {
        name: "DEF",
        role: "Vice President",
        image: "/assets/images/team/p2.jpg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
      {
        name: "ABC",
        role: "Vice President",
        image: "/assets/images/team/p1.jpeg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
      {
        name: "DEF",
        role: "Vice President",
        image: "/assets/images/team/p2.jpg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
      {
        name: "ABC",
        role: "Vice President",
        image: "/assets/images/team/p1.jpeg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
      {
        name: "DEF",
        role: "Vice President",
        image: "/assets/images/team/p2.jpg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
    ],
  },
  {
    title: "Recruiting Team",
    members: [
      {
        name: "ABC",
        role: "VP of Recruiting",
        image: "/assets/images/team/p1.jpeg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
      {
        name: "ABC",
        role: "Recruiting Director",
        image: "/assets/images/team/p2.jpg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
      {
        name: "ABC",
        role: "Recruiting Director",
        image: "/assets/images/team/p1.jpeg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
      {
        name: "ABC",
        role: "Recruiting Director",
        image: "/assets/images/team/p2.jpg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
      {
        name: "ABC",
        role: "Recruiting Director",
        image: "/assets/images/team/p1.jpeg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
    ],
  },
  {
    title: "Accounting & Strategic Growth Team",
    members: [
      {
        name: "ABC",
        role: "VP HR & Strategic Growth Advisor",
        image: "/assets/images/team/p2.jpg",
        bio: `I bring 23 years of enterprise technology sales to my clients. I'm focused on long-term, WIN/WIN client relationships while delivering value. I also offer enterprise sales experience across multiple industries.`,
        linkedin: "https://www.linkedin.com/in/surya-jadhav-98229a246/",
      },
    ],
  },
];

const TeamCard = ({ member }) => {
  const [showBio, setShowBio] = useState(false);

  return (
    <div className="relative group w-full max-w-[440px] h-[500px] overflow-hidden shadow-lg mx-auto">
      <img
        src={member.image}
        alt={member.name}
        className="w-full h-full object-cover object-top grayscale"
      />
      <div
        className={`absolute bottom-0 left-0 w-full transition-all duration-700 ease-in-out text-white ${
          showBio ? "h-full" : "h-[140px]"
        }`}
        style={{ background: "#003466", opacity: 0.85 }}
      >
        <div className="p-4 h-full flex flex-col justify-between">
          <div className="text-left">
            <h3 className="text-xl font-semibold">{member.name}</h3>
            <p className="text-md font-semibold">{member.role}</p>
            <div
              className={`transition-all duration-500 overflow-hidden ${
                showBio ? "max-h-[250px] mt-4 opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-md font-semibold leading-relaxed">{member.bio}</p>
            </div>
          </div>

          <div className="flex justify-between items-center mt-4">
            <button
              onClick={() => setShowBio(!showBio)}
              className={`text-md flex items-center gap-1 font-bold ${
                showBio ? "text-white" : "text-orange-400"
              }`}
            >
              {showBio ? (
                <MinusSquareIcon className="h-5 w-5" />
              ) : (
                <PlusSquareIcon className="h-5 w-5" />
              )}
              {showBio ? "Close Bio" : "Read Bio"}
            </button>

            <a
              href={member.linkedin}
              target="_blank"
              rel="noreferrer"
              className="bg-orange-600 text-white p-2 w-10 h-10 flex items-center justify-center"
            >
              <FaLinkedinIn size={20} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const OurTeam = () => {
  return (
    <div>
      <HeroSection
        title="Our Team"
        breadcrumb={[{ name: "Our Team" }]}
        background="/assets/images/banner.jpg"
      />
      <div className="bg-white px-8 py-16">
        {teamSections.map((section, index) => (
          <div key={index} className="mb-20 text-center">
            <h2 className="text-5xl font-bold mb-2">{section.title}</h2>
            <div className="h-1 w-20 mx-auto bg-orange-500 mb-10 mt-5" />

            <div
              className={`px-4 mx-auto  ${
                section.members.length < 3 ? "max-w-[59rem]" : "max-w-[90rem]"
              }`}
            >
              {section.members.length < 3 ? (
                <div className="flex flex-wrap justify-center gap-8">
                  {section.members.map((member, i) => (
                    <TeamCard key={i} member={member} />
                  ))}
                </div>
              ) : (
                <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                  {section.members.map((member, i) => (
                    <div key={i} className="flex justify-center">
                      <TeamCard member={member} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurTeam;
